const Masks = {
  telefone: (value) => {
    value = value.replace(/\D/g, "");
    if (value.length > 11) value = value.slice(0, 11);

    if (value.length <= 2) return value;
    if (value.length <= 10) {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{4})(\d{1,4})$/, "$1-$2");
    }

    value = value.replace(/^(\d{2})(\d{5})(\d{1,4})$/, "($1) $2-$3");

    return value;
  },
  cpf: (value) => {
    value = value.replace(/\D/g, "");
    if (value.length > 11) value = value.slice(0, 11);
    value = value.replace(/^(\d{3})(\d)/, "$1.$2");
    value = value.replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3");
    value = value.replace(/\.(\d{3})(\d)/, ".$1-$2");
    return value;
  },
  rg: (value) => {
    value = value.toUpperCase();
    value = value.replace(/[^0-9X]/g, "");
    if (value.length > 12) value = value.slice(0, 12);

    value = value.replace(/^(\d{2})(\d)/, "$1.$2");
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");

    return value;
  },
  cnpj: (value) => {
    value = value.replace(/\D/g, "");
    if (value.length > 14) value = value.slice(0, 14);

    value = value.replace(/^(\d{2})(\d)/, "$1.$2");
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
    value = value.replace(/(\d{4})(\d)/, "$1-$2");

    return value;
  },
  inscricaoEstadual: (value) => {
    value = value.replace(/\D/g, "");
    if (value.length > 12) value = value.slice(0, 12);

    return value;
  },
  cep: (value) => {
    value = value.replace(/\D/g, "");
    if (value.length > 8) value = value.slice(0, 8);
    value = value.replace(/^(\d{5})(\d)/, "$1-$2");

    return value;
  },
  uf: (value) => {
    value = value.replace(/[^a-zA-Z]/g, "");
    value = value.toUpperCase();
    if (value.length > 2) value = value.slice(0, 2);
    return value;
  },
  cstIcms: (value) => {
    if (!value) return "";

    value = value.replace(/\D/g, "");

    if (value === "") return "";
    else if (value.length > 4) {
      value = value.slice(0, 4);
    }

    const numero = (parseInt(value, 10) / 100).toFixed(2);
    return numero.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  },

  cstIpi: (value) => {
    if (!value) return "";

    value = value.replace(/\D/g, "");

    if (value === "") return "";
    else if (value.length > 4) {
      value = value.slice(0, 4);
    }

    const numero = (parseInt(value, 10) / 100).toFixed(2);
    return numero.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  },
  dinheiro: (value) => {
    if (!value) return "";

    value = value.replace(/\D/g, "");

    if (value === "") return "";
    else if (value.length > 13) {
      value = value.slice(0, 13);
    }

    const numero = (parseInt(value, 10) / 100).toFixed(2);
    return numero.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  },
  removeMask: (value) => {
    if (!value) return "";
    return value.replace(/\D/g, "");
  }
};

export default Masks;
